import atlassiandemoimg from "../assets/images/Atlassian/overview-of-miniorange-saml-sso-scim-app.webp"
import atlassiandemoimg2 from "../assets/images/Atlassian/customize-login-sso-error-pages-look-feel-in-miniorange-saml-sso.webp"
import atlassiandemoimg3 from "../assets/images/Atlassian/complete-miniorange-oauth-openid-jira.webp"
import atlassiandemoimg4 from "../assets/images/Atlassian/how-to-setup-on-the-fly-group-mapping-jira.webp"
import atlassiandemoimg5 from "../assets/images/Atlassian/how-to-set-up-redirection-rules-jira.webp"
import atlassiandemoimg6 from "../assets/images/Atlassian/how-to-configure-manual-group-mapping-jira.webp"
import atlassiandemoimg7 from "../assets/images/Atlassian/how-to-configure-login-and-logout-pages-jira.webp"
import atlassiandemoimg8 from "../assets/images/Atlassian/how-to-configure-guest-login-feature-confluence.webp"
import atlassiandemoimg9 from "../assets/images/Atlassian/how-to-set-up-miniorange-2fa-for-atlassian.webp"
import atlassiandemoimg10 from "../assets/images/Atlassian/block-brute-force-attacks-on-2fa.webp"  
import atlassiandemoimg11 from "../assets/images/Atlassian/secure-atlassian-apps-with-ip-restrictions.webp"  
import atlassiandemoimg12 from "../assets/images/Atlassian/enhance-atlassian-experience-with-utility-features.webp"  
import atlassiandemoimg13 from "../assets/images/Atlassian/manage-users-track-2fa-activity-in-atlassian.webp"  
import atlassiandemoimg14 from "../assets/images/Atlassian/secure-rest-api-calls-in-atlassian.webp"  
import atlassiandemoimg15 from "../assets/images/Atlassian/integrating-jira-rest-api-with-power-bi.webp"  
import atlassiandemoimg16 from "../assets/images/Atlassian/user-license-management-with-automation.webp"  
import atlassiandemoimg17 from "../assets/images/Atlassian/manage-users-in-bulk-for-atlassian.webp"    
import atlassiandemoimg19 from "../assets/images/Atlassian/configure-custom-domain-for-jsm.webp"  
import atlassiandemoimg20 from "../assets/images/Atlassian/enable-saml-oauth-sso-for-jsm-customers.webp"  
import atlassiandemoimg21 from "../assets/images/Atlassian/seamless-jira-organization-mapping.webp"  
import atlassiandemoimg22 from "../assets/images/Atlassian/secure-manage-jira-portal-access.webp"  
import atlassiandemoimg23 from "../assets/images/Atlassian/user-provisioning-deprovisioning-via-scim.webp"  
import atlassiandemoimg24 from "../assets/images/Atlassian/user-provisioning-deprovisioning-using-rest-api.webp"  
import atlassiandemoimg25 from "../assets/images/Atlassian/sync-portal-customers-in-jsm.webp"  
import atlassiandemoimg26 from "../assets/images/Atlassian/sync-active-directory-ldap-with-jira.webp"  
import atlassiandemoimg27 from "../assets/images/Atlassian/attribute-mapping-in-jira.webp"  
import atlassiandemoimg28 from "../assets/images/Atlassian/custom-attribute-mapping-in-jira.webp"  
import atlassiandemoimg29 from "../assets/images/Atlassian/group-provisioning-deprovisioning-using-scim.webp"  
import atlassiandemoimg30 from "../assets/images/Atlassian/manual-group-mapping-in-jira.webp"   
import atlassiandemoimg32 from "../assets/images/Atlassian/share-confluence-externally-save-licenses.webp"  
import atlassiandemoimg33 from "../assets/images/Atlassian/secure-shared-confluence-link-with-sso.webp"  
import atlassiandemoimg34 from "../assets/images/Atlassian/configure-custom-domain.webp"
import atlassiandemoimg35 from "../assets/images/Atlassian/workflow-thumbnail.jpg"
import atlassiandemoimg36 from "../assets/images/Atlassian/access-atlassian-cloud-apis-using-oauth-tokens-with-rest-api-authentication-app.png"
import atlassiandemoimg37 from "../assets/images/Atlassian/oidc-sso-atlassian-guard-settings-in-jira-cloud-with-miniOrange-how-it-works.png"
import atlassiandemoimg38 from "../assets/images/Atlassian/application-access-and-governance-workflow-demo-for-jira-with-miniOrange-how-it-works.png"
import atlassiandemoimg39 from "../assets/images/Atlassian/scan-and-redact-sensitive-data-with-dlp-pii-scanner-for-jira-cloud-miniOrange.png"
import atlassiandemoimg40 from "../assets/images/Atlassian/configure-detection-rules-templates-&-policies-in-jira-cloud-with-dlp-pii-scanner-miniOrange.png"
import atlassiandemoimg41 from "../assets/images/Atlassian/run-scan-and-redact-violations-on-confluence-pages-with-dlp-pii-scanner-miniOrange.png"
import atlassiandemoimg42 from "../assets/images/Atlassian/create-detection-rules-templates-&-policies-in-confluence-cloud-with-dlp-pii-scanner-miniOrange.png"
import atlassiandemoimg43 from "../assets/images/Atlassian/share-jira-board-with-external-users-using-secure-share-for-jira-cloud-miniOrange.png"
import atlassiandemoimg44 from "../assets/images/Atlassian/share-jira-issues-with-external-users-using-secure-share-for-jira-cloud-miniOrange.png"
import atlassiandemoimg45 from "../assets/images/Atlassian/share-jira-projects-with-external-users-using-secure-share-for-jira-cloud-miniOrange.png"
import atlassiandemoimg46 from "../assets/images/Atlassian/share-jira-filtered-issues-with-external-users-using-secure-share-for-jira-cloud-miniOrange.png"
import atlassiandemoimg47 from "../assets/images/Atlassian/get-actionable-insights-with-user-management-dashboard-for-jira-cloud-miniOrange.png"
import atlassiandemoimg48 from "../assets/images/Atlassian/manage-user-accounts-and-filters-with-automated-user-management-for-jira-cloud-miniOrange.png"
import atlassiandemoimg49 from "../assets/images/Atlassian/automate-user-cleanup-&-scheduler-rules-with-automated-user-management-for-jira-cloud-miniOrange.png"
import atlassiandemoimg50 from "../assets/images/Atlassian/run-user-analysis-with-dlp-scanner-and-cloud-migration-assistant-for-confluence-miniOrange.png"
import atlassiandemoimg51 from "../assets/images/Atlassian/scan-and-secure-data-with-dlp-scanner-and-cloud-migration-assistant-for-confluence-miniOrange.png"
import atlassiandemoimg52 from "../assets/images/Atlassian/oauth-sso-for-jsm-customers-miniOrange.png"
import atlassiandemoimg53 from "../assets/images/Atlassian/user-provisioning-with-scim-based-idP-on-jira-cloud-setup-live-demo-miniOrange.png"
import atlassiandemoimg54 from "../assets/images/Atlassian/scim-based-user-provisioning-in-jira-service-management-portal-miniOrange.png"
import atlassiandemoimg55 from "../assets/images/Atlassian/manual-group-mapping-for-user-provisioning-in-jira-cloud-miniOrange.png"
import atlassiandemoimg56 from "../assets/images/Atlassian/custom-customer-attributes-for-jsm-portal-using-scim-provisioning-miniOrange.png"
import atlassiandemoimg57 from "../assets/images/Atlassian/rest-api-based-user-provisioning-in-jira-cloud-miniOrange.png"
import atlassiandemoimg58 from "../assets/images/Atlassian/on-the-fly-group-mapping-for-scim-provisioning-miniOrange.png"
import atlassiandemoimg59 from "../assets/images/Atlassian/how-to-set-up-2fa-for-jira-service-management-portal-customers-miniOrange.png"
import atlassiandemoimg60 from "../assets/images/Atlassian/page-edit-support-for-external-users-with-secure-share-for-confluence-cloud.png"


export const atlassianData = [
    {
        text: "Overview of miniOrange SAML SSO & SCIM App",
        icon:<img src={atlassiandemoimg}  />,
        videoId:"Tfvrfqw70dU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SAML SSO",
        tags: ['SAML single sign on ', 'saml scim provisioning', 'saml and scim', 'saml single sign on sso jira saml sso','scim provisioning'],
        desc:"",
    },
    {
        text: "Customize Login & SSO Error Pages",
        icon:<img src={atlassiandemoimg2}  />,
        videoId:"AZqiaQo1sLw",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SAML SSO",
        tags: ['SAML single sign on error  ', 'saml authentication error', 'how to fix saml error', 'saml authentication failed','how to set up single sign on'],
        desc:"",
    },
    {
        text: "Setup OAuth/OIDC SSO for Jira Cloud ",
        icon:<img src={atlassiandemoimg37}  />,
        videoId:"NJX5iZM9V0Y",
        videoType:"youtube",
        isMultiple: false,
        cardType: "OAuth SSO",
        deployType: "cloud",
        tags: ['oauth sso', 'oauth single sign on', 'openid connect single sign on', 'oauth openid connect','single sign on with oauth'],
        desc:"",
    },
    {
        text: "Complete OAuth/OIDC SSO Setup Demo for Jira",
        icon:<img src={atlassiandemoimg3}  />,
        videoId:"KvIl9etRhDM",
        videoType:"youtube",
        isMultiple: false,
        cardType: "OAuth SSO",
        deployType: "dc",
        tags: ['oauth sso', 'oauth single sign on', 'openid connect single sign on', 'oauth openid connect','single sign on with oauth'],
        desc:"",
    },
    {
        text: "On-The-Fly Group Mapping Demo for Jira",
        icon:<img src={atlassiandemoimg4}  />,
        videoId:"ZRWpvKWdsJw",
        videoType:"youtube",
        isMultiple: false,
        cardType: "OAuth SSO",
        deployType: "dc",
        tags: ['oauth sso', 'oauth single sign on', 'openid connect single sign on', 'oauth openid connect','single sign on with oauth'],
        desc:"",
    },
    {
        text: "Redirection Rules Setup Demo for Jira",
        icon:<img src={atlassiandemoimg5}  />,
        videoId:"VyUcrj_9t5E",
        videoType:"youtube",
        isMultiple: false,
        cardType: "OAuth SSO",
        deployType: "dc",
        tags: ['oauth sso', 'oauth single sign on', 'openid connect single sign on', 'oauth openid connect','single sign on with oauth'],
        desc:"",
    },
     {
        text: "Manual Group Mapping Demo for Jira",
        icon:<img src={atlassiandemoimg6}  />,
        videoId:"2BS8KUPCgeI",
        videoType:"youtube",
        isMultiple: false,
        cardType: "OAuth SSO",
        deployType: "dc",
        tags: ['oauth sso', 'oauth single sign on', 'openid connect single sign on', 'oauth openid connect','single sign on with oauth'],
        desc:"",
    },
     {
        text: "Login & Logout Page Customization Demo for Jira",
        icon:<img src={atlassiandemoimg7}  />,
        videoId:"7qe2uASVdYw",
        videoType:"youtube",
        isMultiple: false,
        cardType: "OAuth SSO",
        deployType: "dc",
        tags: ['oauth sso', 'oauth single sign on', 'openid connect single sign on', 'oauth openid connect','single sign on with oauth'],
        desc:"",
    },
    {
        text: "Guest Login Feature Demo for Confluence",
        icon:<img src={atlassiandemoimg8}  />,
        videoId:"HttQuHvP3zU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "OAuth SSO",
        deployType: "dc",
        tags: ['oauth sso', 'oauth single sign on', 'openid connect single sign on', 'oauth openid connect','single sign on with oauth'],
        desc:"",
    },
    {
        text: "Setup 2FA Cloud For JSM Portal",
        icon:<img src={atlassiandemoimg59}  />,
        videoId:"Sd3YDPgo6mw",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Two Factor Authentication (2FA)",
        deployType: "cloud",
        tags: ['Two Factor Authentication (2FA)', 'Atlassian 2FA ','Brute Force Protection 2FA','User Management Jira ','Jira 2FA', 'JSM Portal 2FA'],
        desc:"",
    },
    {
        text: "How to Set Up miniOrange 2FA for Atlassian",
        icon:<img src={atlassiandemoimg9}  />,
        videoId:"EorouAGaUe0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Two Factor Authentication (2FA)",
        deployType: "dc",
        tags: ['Two Factor Authentication (2FA)', 'Atlassian 2FA ','Brute Force Protection 2FA','User Management Jira ','Jira 2FA '],
        desc:"",
    },
    {
        text: "Block Brute Force Attacks on 2FA",
        icon:<img src={atlassiandemoimg10}  />,
        videoId:"4oenczWKCaU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Two Factor Authentication (2FA)",
        deployType: "dc",
        tags: ['Two Factor Authentication (2FA)', 'Atlassian 2FA ','Brute Force Protection 2FA','User Management Jira ','Jira 2FA '],
        desc:"",
    },
    {
        text: "Set IP Restrictions Through 2FA App ",
        icon:<img  src={atlassiandemoimg11}  />,
        videoId:"OzkK5Cvc1L4",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Two Factor Authentication (2FA)",
        deployType: "dc",
        tags: ['Two Factor Authentication (2FA)', 'Atlassian 2FA ','Brute Force Protection 2FA','User Management Jira ','Jira 2FA '],
        desc:"",
    },
    {
        text: "2FA App Utility Features",
        icon:<img  src={atlassiandemoimg12}  />,
        videoId:"PmHkJvdeaFw",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Two Factor Authentication (2FA)",
        deployType: "dc",
        tags: ['Two Factor Authentication (2FA)', 'Atlassian 2FA ','Brute Force Protection 2FA','User Management Jira ','Jira 2FA '],
        desc:"",
    },
    {
        text: "Manage Users & Track 2FA Activity in Atlassian",
        icon:<img  src={atlassiandemoimg13}  />,
        videoId:"bDO02kRrhz0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Two Factor Authentication (2FA)",
        deployType: "dc",
        tags: ['Two Factor Authentication (2FA)', 'Atlassian 2FA ','Brute Force Protection 2FA','User Management Jira ','Jira 2FA '],
        desc:"",
    },
    {
        text: "Scan and Redact Sensitive Data in Jira Cloud",
        icon:<img  src={atlassiandemoimg39}  />,
        videoId:"X2NF9sGiLTw",
        videoType:"youtube",
        isMultiple: false,
        cardType: "DLP PII Scanner",
        tags: ['DLP PII Scanner', 'DLP PII Scanner Jira ','DLP PII Scanner Jira Cloud ','DLP PII Scanner Confluence','Data Scanner Jira Software'],
        desc:"",
    },
    {
        text: "Configure Detection Rules, Templates & Policies in Jira Cloud",
        icon:<img  src={atlassiandemoimg40}  />,
        videoId:"hYhMyxkRz9g",
        videoType:"youtube",
        isMultiple: false,
        cardType: "DLP PII Scanner",
        tags: ['DLP PII Scanner', 'DLP PII Scanner Jira ','DLP PII Scanner Jira Cloud ','DLP PII Scanner Confluence','Data Scanner Jira Software'],
        desc:"",
    },
    {
        text: "Scan and Redact Sensitive PII Data in Confluence Cloud",
        icon:<img  src={atlassiandemoimg41}  />,
        videoId:"T7tkiaog7no",
        videoType:"youtube",
        isMultiple: false,
        cardType: "DLP PII Scanner",
        tags: ['DLP PII Scanner', 'DLP PII Scanner Jira ','DLP PII Scanner Jira Cloud ','DLP PII Scanner Confluence','Data Scanner Jira Software'],
        desc:"",
    },
    {
        text: "Setup Detection Rules, Templates & Policies in Confluence Cloud",
        icon:<img  src={atlassiandemoimg42}  />,
        videoId:"T0k1nIkbHpk",
        videoType:"youtube",
        isMultiple: false,
        cardType: "DLP PII Scanner",
        tags: ['DLP PII Scanner', 'DLP PII Scanner Jira ','DLP PII Scanner Jira Cloud ','DLP PII Scanner Confluence','Data Scanner Jira Software'],
        desc:"",
    },
    {
        text: "Use OAuth Tokens to Access Atlassian Cloud APIs",
        icon:<img  src={atlassiandemoimg36}  />,
        videoId:"hqAXQN-aw9o",
        videoType:"youtube",
        isMultiple: false,
        cardType: "API Authentication",
        deployType: "cloud",
        tags: ['Jira API','Power BI','API Authentication','OAuth 2.0','Rest API Jira '],
        desc:"",
    },
    {
        text: "Secure REST API Calls in Atlassian",
        icon:<img  src={atlassiandemoimg14}  />,
        videoId:"6iTY-6l0524",
        videoType:"youtube",
        isMultiple: false,
        cardType: "API Authentication",
        deployType: "dc",
        tags: ['Jira API','Power BI','API Authentication','OAuth 2.0','Rest API Jira '],
        desc:"",
    },
    {
        text: "Integrating Jira REST API with Power BI",
        icon:<img  src={atlassiandemoimg15}  />,
        videoId:"4jfOGkwaMFg",
        videoType:"youtube",
        isMultiple: false,
        cardType: "API Authentication",
        deployType: "dc",
        tags: ['Jira API','Power BI','API Authentication','OAuth 2.0','Rest API Jira '],
        desc:"",
    },
    {
        text: "User Management Dashboard for Jira Cloud",
        icon:<img  src={atlassiandemoimg47}  />,
        cardType: "Automated User Management",
        isMultiple: false,
        videoId: "SlumOuKYE2k",
        videoType: "youtube",
        deployType: "cloud",
        tags: ['automated user management', 'jira sso','bulk user management','Jira Single SIgn On ','Bulk Delete Users Jira '],
        desc:"",
    },
    {
        text: "Manage Users in Jira Cloud with Advanced Filters and Bulk Actions",
        icon:<img  src={atlassiandemoimg48}  />,
        cardType: "Automated User Management",
        isMultiple: false,
        videoId: "GzjyZRr8mjk",
        videoType: "youtube",
        deployType: "cloud",
        tags: ['automated user management', 'jira sso','bulk user management','Jira Single SIgn On ','Bulk Delete Users Jira '],
        desc:"",
    },
    {
        text: "Automate User Cleanup & Scheduler Rules for Jira Cloud",
        icon:<img  src={atlassiandemoimg49}  />,
        cardType: "Automated User Management",
        isMultiple: false,
        videoId: "4D81N0D3X48",
        videoType: "youtube",
        deployType: "cloud",
        tags: ['automated user management', 'jira sso','bulk user management','Jira Single SIgn On ','Bulk Delete Users Jira '],
        desc:"",
    },
    {
        text: "How to Automate User License Management",
        icon:<img  src={atlassiandemoimg16}  />,
        cardType: "Automated User Management",
        isMultiple: false,
        videoId: "dytrZVrfbxo",
        videoType: "youtube",
        deployType: "dc",
        tags: ['automated user management', 'jira sso','bulk user management','Jira Single SIgn On ','Bulk Delete Users Jira '],
        desc:"",
    },
    {
        text: "Perform Bulk Actions on Users in Atlassian",
        icon:<img  src={atlassiandemoimg17}  />,
        isMultiple: false,
        videoType: "youtube",
        cardType: "Automated User Management",
        videoId: "yDiR9DnoVlo",
        deployType: "dc",
        tags: ['automated user management', 'jira sso','bulk user management','Jira Single SIgn On ','Bulk Delete Users Jira '],
        desc:"",
    },
    {
        text: "End User Feature Setup & Knowledge Base in JSM SSO",
        icon:<img  src={atlassiandemoimg52}  />,
        isMultiple: false,
        videoType: "youtube",
        cardType: "JSM SSO",
        videoId: "2WVZagfgxuE",
        tags: ['Jira SSO', 'JSM','Single Sign-On','Jira Service Management','JSM Oauth'],
        desc:"",
    },
    {
        text: "How to Configure Custom Domain for JSM",
        icon:<img  src={atlassiandemoimg19}  />,
        videoId:"cAunJIZJxRE",
        videoType:"youtube",
        isMultiple: false,
        cardType: "JSM SSO",
        tags: ['Jira SSO', 'JSM','Single Sign-On','Jira Service Management','JSM Oauth'],
        desc:"",
    },
    {
        text: "How to Enable SAML/OAuth SSO for JSM Customers",
        icon:<img  src={atlassiandemoimg20}  />,
        videoId:"IHCFbciqvTg",
        videoType:"youtube",
        isMultiple: false,
        cardType: "JSM SSO",
        tags: ['Jira SSO', 'JSM','Single Sign-On','Jira Service Management','JSM Oauth'],
        desc:"",
    },
    {
        text: "Automate User Management in JSM",
        icon:<img  src={atlassiandemoimg21}  />,
        videoId:"8q_Z3R1WtuQ",
        videoType:"youtube",
        isMultiple: false,
        cardType: "JSM SSO",
        tags: ['Jira SSO', 'JSM','Single Sign-On','Jira Service Management','JSM Oauth'],
        desc:"",
    },
    {
        text: "Secure & Manage Jira Portal Access",
        icon:<img  src={atlassiandemoimg22}  />,
        videoId:"6DQB-FBupSk",
        videoType:"youtube",
        isMultiple: false,
        cardType: "JSM SSO",
        tags: ['Jira SSO', 'JSM','Single Sign-On','Jira Service Management','JSM Oauth'],
        desc:"",
    },
    {
        text: "User Provisioning with SCIM-based IdP on Jira Cloud",
        icon:<img  src={atlassiandemoimg53}  />,
        videoId:"TEppoiQ3ejo",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "cloud",
        tags: ['SCIM SAML SSO ', 'auth', 'endpoint'],
        desc:"",
    },
    {
        text: "SCIM-Based User Provisioning in JSM",
        icon:<img  src={atlassiandemoimg54}  />,
        videoId:"6iDZRCEj4eU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "cloud",
        tags: ['SCIM SAML SSO ', 'auth', 'endpoint'],
        desc:"",
    },
    {
        text: "Manual Group Mapping with SCIM in Jira Cloud",
        icon:<img  src={atlassiandemoimg55}  />,
        videoId:"H004QJ3A6KQ",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "cloud",
        tags: ['SCIM SAML SSO ', 'auth', 'endpoint'],
        desc:"",
    },
    {
        text: "Set Custom Customer Attributes for JSM",
        icon:<img  src={atlassiandemoimg56}  />,
        videoId:"ejRI-v639hY",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "cloud",
        tags: ['SCIM SAML SSO ', 'auth', 'endpoint'],
        desc:"",
    },
    {
        text: "REST API-Based User Provisioning in Jira Cloud",
        icon:<img  src={atlassiandemoimg57}  />,
        videoId:"d8vD7ytSGLw",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "cloud",
        tags: ['SCIM SAML SSO ', 'auth', 'endpoint'],
        desc:"",
    },
    {
        text: "On-The-Fly Group Mapping for SCIM Provisioning in Jira Cloud",
        icon:<img  src={atlassiandemoimg58}  />,
        videoId:"nrrFDZ4fXho",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "cloud",
        tags: ['SCIM SAML SSO ', 'auth', 'endpoint'],
        desc:"",
    },
    {
        text: "Sync Active Directory & LDAP with Jira",
        icon:<img  src={atlassiandemoimg26}  />,
        videoId:"sxmaTSqN36M",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "cloud",
        tags: ['passwordless', 'User Provisioning', 'Atlassian SCIM ','Atlassian API Authentication','SCIM Group Provisioning'],
        desc:"",
    },
    {
        text: "User Provisioning & Deprovisioning Via SCIM",
        icon:<img  src={atlassiandemoimg23}  />,
        videoId:"qHn4WFjDibA",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "dc",
        tags: ['SCIM SAML SSO ', 'auth', 'endpoint'],
        desc:"",
    },
    {
        text: "User Provisioning & Deprovisioning Using REST API",
        icon:<img  src={atlassiandemoimg24}  />,
        videoId:"GOYSBuWbGG8",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "dc",
        tags: ['passwordless', 'User Provisioning', 'Atlassian SCIM ','Atlassian API Authentication','SCIM Group Provisioning'],
        desc:"",
    },
    {
        text: "Sync Portal Customers in JSM Using SCIM",
        icon:<img  src={atlassiandemoimg25}  />,
        videoId: "Lgus7u7p8pY",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "dc",
        tags: ['passwordless', 'User Provisioning', 'Atlassian SCIM ','Atlassian API Authentication','SCIM Group Provisioning'],
    },
    {
        text: "Sync User Data from IDP with SCIM (Attribute Mapping)",
        icon:<img  src={atlassiandemoimg27}  />,
        videoId:"pX8JC4SCF0Y",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "dc",
        tags: ['passwordless', 'User Provisioning', 'Atlassian SCIM ','Atlassian API Authentication','SCIM Group Provisioning'],
        desc:"",
    },
    {
        text: "Add & Sync Custom Fields with SCIM (Custom Attribute Mapping)",
        icon:<img  src={atlassiandemoimg28}  />,
        videoId:"TcRzrXydV7E",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "dc",
        tags: ['passwordless', 'User Provisioning', 'Atlassian SCIM ','Atlassian API Authentication','SCIM Group Provisioning'],
        desc:"",
    },
    {
        text: "Group Provisioning & Deprovisioning Using SCIM",
        icon:<img  src={atlassiandemoimg29}  />,
        videoId:"sUAOHzPFbJA",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "dc",
        tags: ['passwordless', 'User Provisioning', 'Atlassian SCIM ','Atlassian API Authentication','SCIM Group Provisioning'],
        desc:"",
    },
   
    {
        text: "Manual Group Mapping in Jira",
        icon:<img  src={atlassiandemoimg30}  />,
        videoId:"LZIf9IoRsBI",
        videoType:"youtube",
        isMultiple: false,
        cardType: "SCIM",
        deployType: "dc",
        tags: ['passwordless', 'User Provisioning', 'Atlassian SCIM ','Atlassian API Authentication','SCIM Group Provisioning'],
        desc:"",
    },
    {
        text: "Share Jira Board with External Users",
        icon:<img  src={atlassiandemoimg43}  />,
        videoId:"s0wiVVzaSDo",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Jira Projects', 'Jira External Users', 'Jira Secure Sharing', 'Custom Domain IDP', 'Atlassian Jira Cloud'],
        desc:"",
    },
    {
        text: "Share Jira Issues to Collaborate with External Users",
        icon:<img  src={atlassiandemoimg44}  />,
        videoId:"0Uze_jsX0hY",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Jira Projects', 'Jira External Users', 'Jira Secure Sharing', 'Custom Domain IDP', 'Atlassian Jira Cloud'],
        desc:"",
    },
    {
        text: "Share Jira Cloud Projects with Secure Share",
        icon:<img  src={atlassiandemoimg45}  />,
        videoId:"_B4HwPpFTPU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Jira Projects', 'Jira External Users', 'Jira Secure Sharing','Custom Domain IDP', 'Atlassian Jira Cloud'],
        desc:"",
    },
    {
        text: "Share Filtered Jira Issues with Secure Share",
        icon:<img  src={atlassiandemoimg46}  />,
        videoId:"NQ6fz-AvB9g",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Jira Projects', 'Jira External Users', 'Jira Secure Sharing','Custom Domain IDP', 'Atlassian Jira Cloud'],
        desc:"",
    },
    {
        text: "Confluence Page Edit Support for External Users",
        icon:<img  src={atlassiandemoimg60}  />,
        videoId:"_GLyGdnjaE0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Confluence', 'Confluence External Users', 'Confluence Secure Sharing', 'Share Confluence pages', 'Atlassian Confluence Cloud'],
        desc:"",
    },
    {
        text: "Share Confluence Externally & Save Licenses",
        icon:<img  src={atlassiandemoimg32}  />,
        videoId:"iVt01a0kC18",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Confluence', 'Confluence External Users', 'Confluence Secure Sharing', 'Share Confluence pages', 'Atlassian Confluence Cloud'],
        desc:"",
    },
    {
        text: "Secure Shared Confluence Link with SSO",
        icon:<img  src={atlassiandemoimg33}  />,
        videoId:"KF6nbq8bDsg",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Confluence', 'Confluence External Users', 'Confluence Secure Sharing', 'Share Confluence pages', 'Atlassian Confluence Cloud'],
        desc:"",
    },
    {
        text: "Personalize Confluence Page & Space Links",
        icon:<img  src={atlassiandemoimg34}  />,
        videoId:"6579jc0gfE0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Secure Share",
        tags: ['Share Confluence', 'Confluence External Users', 'Confluence Secure Sharing', 'Share Confluence pages', 'Atlassian Confluence Cloud'],
        desc:"",
    },
    {
        text: "Setup Application Access Governance for Jira Cloud",
        icon:<img  src={atlassiandemoimg38}  />,
        videoId:"D17nBKhOC0o",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Workflow",
        deployType: "cloud",
        tags: ['Jira Access Request Management', 'workflow', 'Automated Approvals in Jira Service Management'],
        desc:"",
    },
    {
        text: "Automate Access Requests & Provisioning in Jira",
        icon:<img  src={atlassiandemoimg35}  />,
        videoId:"k1QIUcdSHt0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Workflow",
        deployType: "dc",
        tags: ['Jira Access Request Management', 'workflow', 'Automated Approvals in Jira Service Management'],
        desc:"",
    },
    {
        text: "Run User Analysis and Scan Dormant Users in Confluence",
        icon:<img  src={atlassiandemoimg50}  />,
        videoId:"SZsW9gZHWbQ",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Migration Assistant",
        tags: ['Migration Assistant', 'DC Migration', 'Data Scanner and Migration Assistant', 'Migrate Confluence'],
        desc:"",
    },
    {
        text: "Detect, Redact, and Encrypt Sensitive Data in Confluence",
        icon:<img  src={atlassiandemoimg51}  />,
        videoId:"QAH4rkOiMa8",
        videoType:"youtube",
        isMultiple: false,
        cardType: "Migration Assistant",
        tags: ['Migration Assistant', 'DC Migration', 'Data Scanner and Migration Assistant', 'Migrate Confluence'],
        desc:"",
    }
]

export const tabs = [
    { label: "SAML SSO", key: "saml-sso-demo",  value: "saml-sso"},
    { label: "OAuth SSO", key: "oauth-sso", value: "oauth-sso"},
    { label: "Two Factor Authentication (2FA)", key: "two-factor-authentication-2fa", value: "2fa"},
    { label: "DLP PII Scanner", key: "dlp-pii-scanner", value: "dlp"},
    { label: "API Authentication", key: "api-authentication", value: "api-authentication"},
    { label: "Automated User Management", key: "automated-user-management", value: "user-management" },
    { label: "JSM SSO", key: "jsm-sso", value: "jsm-sso"},
    { label: "SCIM", key: "scim", value: "scim"},
    { label: "Secure Share", key: "secure-share", value: "secure-share"},
    { label: "Workflow", key: "Workflow", value: "workflow"},
    { label: "Migration Assistant", key: "migration-assistant", value: "migration-assistant"}
  ];